import { Dispatch } from "redux";
import { ThunkDispatch } from "redux-thunk";

import createValueModule from "@redux/create-value-module";
import { IState, TExtraThunkArgs, TValueAction } from "@redux/store.types";

import { getErrors } from "./errors.selectors";
import { $ErrorsModuleName, Error, TErrorsState } from "./errors.types";

const { constants: _constants, actions } = createValueModule<TErrorsState>(
    $ErrorsModuleName,
    {
        alerts: [],
    },
);

export const setError =
    (error: Error) =>
    (
        dispatch: ThunkDispatch<IState, TExtraThunkArgs, TValueAction>,
        getState: any,
    ) => {
        const alerts = getErrors(getState()) || [];
        let newAlertArray = [...alerts];
        const index = alerts.findIndex(
            (alert: any) =>
                alert.url === error.url && alert.method === error.method,
        );
        if (index !== -1) {
            newAlertArray = [
                ...alerts.slice(0, index),
                ...alerts.slice(index + 1),
            ];
        }
        newAlertArray.push(error);
        return dispatch(set({ alerts: newAlertArray }));
    };

export const deleteError =
    (error: Error) =>
    (
        dispatch: ThunkDispatch<IState, TExtraThunkArgs, TValueAction>,
        getState: any,
    ) => {
        const alerts = getErrors(getState()) || [];
        let newAlertArray = [...alerts];
        const index = alerts.findIndex(
            (alert: any) =>
                alert.url === error.url && alert.method === error.method,
        );
        if (index !== -1) {
            newAlertArray = [
                ...alerts.slice(0, index),
                ...alerts.slice(index + 1),
            ];
        }
        return dispatch(set({ alerts: newAlertArray }));
    };

export const clear = actions.clear;
export const set = actions.set;
export const update = actions.update;

export const constants = _constants;
